import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "../style/inventoryTransfer.css";
import ContentWrapper from "../../../../common/components/contentWrapper";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { Button, DialogActions, Dialog, TextField, FormControl, Checkbox, FormControlLabel } from "@material-ui/core";
import { invoiceDataList, invoiceReject } from "../../dashboard/actions/dashboardAction";
import { Typography } from "antd";
import { SpinnerRoundFilled } from "spinners-react";
import ViewInvoicemodel from "./ViewInvoicemodel";
import imageNotAvailable from "../../../../assests/images/img-soon.png";
import CircularProgress from "@material-ui/core/CircularProgress";
import InfoIcon from '@mui/icons-material/Info';
const yn = (v) => v === "Yes" || v === true;
const YesNo = ({ val }) => (
  <span className={val ? "it-yes" : "it-no"}>{val ? "Yes" : "No"}</span>
);

const InventoryTransferComponent = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const currentUser = useSelector((state) => state.auth?.currentUser);
  const accountId = useSelector(
    (state) =>
      state.auth?.accountId || state.auth?.currentUser?.accountId ||
      window.sessionStorage.getItem("accountId")
  );
  const [transfers, setTransfers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState("pending");
  const [counts, setCounts] = useState({ pending: 0, rejected: 0, accepted: 0 });
  const [rejectModal, setRejectModal] = useState(null);
  const [acceptModal, setAcceptModal] = useState(null);
  const [rejectNotes, setRejectNotes] = useState("");
  const [rejecting, setRejecting] = useState(false);  
  const [viewInvoiceModal, setViewInvoiceModal] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [confirmAccepts, setConfirmAccepts] = useState(false);
  const [includeShopify, setIncludeShopify] = useState(false);
  const [includeQbo, setIncludeQbo] = useState(false);

  const inventoryName =
    acceptModal?.inventory_title ||
    acceptModal?.model ||
    acceptModal?.serialno ||
    "";

  const updateTransferPendingCount = (delta) => {
    try {
      const storedUser = window.sessionStorage.getItem("userDetails");
      if (!storedUser) {
        return;
      }
      const parsedUser = JSON.parse(storedUser);
      const currentCount = Number(
          parsedUser?.transfer_pendingcount ??
          currentUser?.transferPendingCount ??
          currentUser?.transfer_pendingcount ??
          0
      );
      const nextCount = Math.max(0, currentCount + delta);
      const updatedUser = {
        ...parsedUser,
        ...currentUser,
        transferPendingCount: nextCount,
      };
      window.sessionStorage.setItem("userDetails", JSON.stringify(updatedUser));
      window.dispatchEvent(new Event("userDetailsUpdated"));
    } catch (error) {
      console.error("Unable to update transfer pending count", error);
    }
  };

  useEffect(() => {
    if (!accountId) {
      console.warn("accountId is missing — invoiceDataList will NOT be called");
      return;
    }
    const status =
      activeTab === "pending"
        ? "Pending"
        : activeTab === "rejected"
        ? "Rejected"
        : "Approved";
    setLoading(true);
    setError(null);

    dispatch(invoiceDataList({ accountId, status }))
      .then((response) => {
        const responseData = response?.data?.data ?? response?.data ?? [];
        const data = Array.isArray(responseData) ? responseData : [];
        if (!Array.isArray(responseData)) {
          console.warn("invoiceDataList returned non-array data:", responseData);
        }
        setTransfers(data);
        setCounts((prev) => ({
          ...prev,
          pending: Number(response?.data?.pending_count) ?? prev.pending,
          accepted: Number(response?.data?.approved_count) ?? prev.accepted,
          rejected: Number(response?.data?.rejected_count) ?? prev.rejected,
        }));
      })
      .catch((err) => {
        console.error("invoiceDataList error:", err);
        setError(err);
      })
      .finally(() => setLoading(false));
  }, [accountId, activeTab, dispatch]);

  const pendingCount = counts.pending;
  const rejectedCount = counts.rejected;
  const displayList = transfers;

  useEffect(() => {
    if (acceptModal) {
      setIncludeShopify(false);
      setIncludeQbo(false);
    }
  }, [acceptModal]);

  const isShopifyVerified = () =>
    window.sessionStorage.getItem("isShopifyVerified") === "true";
  const isQboVerified = () =>
    window.sessionStorage.getItem("isQboVerified") === "true";

  const confirmAccept = (t) => {
    setConfirmAccepts(true);
    const payload = {
      transferid: [t.transferid ?? t.id],
      status: "Approved",
    };
     if (isShopifyVerified()) {
      payload.is_include_shopify = includeShopify;
    }
    if (isQboVerified()) {
      payload.is_include_qbo = includeQbo;
    }

    dispatch(invoiceReject(payload))
      .then(() => {
        updateTransferPendingCount(-1);
        setAcceptModal(null);
        fetchTransfers();
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setConfirmAccepts(false);
      });
  };

  const formatDate = (date) => {
    if (!date) return "—";
    const d = new Date(date);
    const month = String(d.getUTCMonth() + 1).padStart(2, "0");
    const day = String(d.getUTCDate()).padStart(2, "0");
    const year = d.getUTCFullYear();

    return `${month}/${day}/${year}`;
  };

  const handleOverlayClick = (e, closeFn) => {
    if (e.target === e.currentTarget) closeFn();
  };
  const openInvoice = (t) => {
    setSelectedInvoice(t);
    setViewInvoiceModal(true);
  };

  const fetchTransfers = () => {
    if (!accountId) {
      console.warn("accountId is missing — invoiceDataList will NOT be called");
      return;
    }
    const status = activeTab === "pending" ? "Pending" : "Rejected";
    setLoading(true);
    setError(null);

    dispatch(invoiceDataList({ accountId, status }))
      .then((response) => {
        const responseData = response?.data?.data ?? response?.data ?? [];
        const data = Array.isArray(responseData) ? responseData : [];
        if (!Array.isArray(responseData)) {
          console.warn("invoiceDataList returned non-array data:", responseData);
        }
        setTransfers(data);
       setCounts((prev) => ({
          ...prev,
          pending: Number(response?.data?.pending_count) ?? prev.pending,
          accepted: Number(response?.data?.approved_count) ?? prev.accepted,
          rejected: Number(response?.data?.rejected_count) ?? prev.rejected,
        }));
      })
      .catch((err) => {
        console.error("invoiceDataList error:", err);
        setError(err);
      })
      .finally(() => setLoading(false));
  };

  // useEffect(() => {
  //   console.log("InventoryTransfer mount — accountId:", accountId);
  //   fetchTransfers();
  // }, [accountId, activeTab, dispatch]);

  const confirmReject = (t) => {
    setRejecting(true);
    const payload = {
      transferid: [t.transferid ?? t.id],
      status: "Rejected",
      notes: rejectNotes
    };

    dispatch(invoiceReject(payload))
      .then((response) => {
        updateTransferPendingCount(-1);
        setRejectModal(null);
        setRejectNotes("");
        fetchTransfers();
      })
      .catch((err) => {
        console.error("invoiceReject error:", err);
      })
      .finally(() => setRejecting(false));
  };

  const handleCloseAction = () => {
    setViewInvoiceModal(false);
    setSelectedInvoice(null);
  };
  const getImageList = (t) => {
    const source = t.inventory_images || t.product_images;
    if (!source) return [];

    if (Array.isArray(source)) {
      return source.filter(Boolean);
    }
    if (typeof source === "object") {
      return Object.values(source).filter(Boolean);
    }
    if (typeof source === "string") {
      return [source];
    }
    return [];
  };
  const InventoryPhoto = ({ t }) => {
  const images = getImageList(t);
  const hasImages = images.length > 0;
  const [index, setIndex] = useState(0);
  const currentSrc = hasImages ? images[index] : imageNotAvailable;

  const handlePrev = (e) => {
    e.stopPropagation();
    setIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  const handleNext = (e) => {
    e.stopPropagation();
    setIndex((prev) => (prev + 1) % images.length);
  };

  return (
    <div className="it-photo">
      <img
        src={currentSrc}
        alt={t.inventory_title || "Inventory item"}
        className="it-photo-img"
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = imageNotAvailable;
        }}
      />
      {hasImages && images.length > 1 && (
        <>
          <button
            type="button"
            className="it-photo-nav it-photo-prev"
            onClick={handlePrev}
            aria-label="Previous image"
          >
            ‹
          </button>
          <button
            type="button"
            className="it-photo-nav it-photo-next"
            onClick={handleNext}
            aria-label="Next image"
          >
            ›
          </button>
        </>
      )}
    </div>
    );
  };

  /* ── Shared field grid ── */
  const renderFields = (t) => (
    <div className="it-fields">
      <div className="it-col">
        <div className="it-field">
          <Typography className="it-fl">Model Number :</Typography>
          <Typography className="it-fv">{t.model || "—"}</Typography>
        </div>
        <div className="it-field">
          <Typography className="it-fl">Inventory Title :</Typography>
          <Typography className="it-fv">{t.inventory_title || "—"}</Typography>
        </div>
        <div className="it-field">
          <Typography className="it-fl">Serial Number :</Typography>
          <Typography className="it-fv">{t.serialno || "—"}</Typography>
        </div>
        <div className="it-field">
          <Typography className="it-fl">Warranty Card :</Typography>
          <Typography className="it-fv"><YesNo val={yn(t.warrantybox || "—")} /></Typography>
        </div>
        <div className="it-field">
          <Typography className="it-fl">Archive :</Typography>
          <Typography className="it-fv"><YesNo val={yn(t.archive || "—")} /></Typography>
        </div>
        <div className="it-field">
          <Typography className="it-fl">Service :</Typography>
          <Typography className="it-fv"><YesNo val={yn(t.is_service || "—")} /></Typography>
        </div>
        {/* <div className="it-field">
          <Typography className="it-fl">Serialized Tag :</Typography>
          <Typography className="it-fv">{t.dialcolor}</Typography>
        </div> */}
        <div className="it-field">
          <Typography className="it-fl">Public Notes :</Typography>
          <Typography className="it-notes">
            {t.publicnotes || "—"}
          </Typography>
        </div>
      </div>
      <div className="it-col">
        <div className="it-field">
          <Typography className="it-fl">Warranty Date :</Typography>
          <Typography className="it-fv">{formatDate(t.warrantydate)}</Typography>
        </div>
        <div className="it-field">
          <Typography className="it-fl">Archive Date :</Typography>
          <Typography className="it-fv">{formatDate(t.archive_date)}</Typography>
        </div>
        <div className="it-field">
          <Typography className="it-fl">Service Date :</Typography>
          <Typography className="it-fv">{formatDate(t.service_date)}</Typography>
        </div>
        <div className="it-field">
          <Typography className="it-fl">Condition :</Typography>
          <Typography className="it-fv">{t.condition || "—"}</Typography>
        </div>
        <div className="it-field">
          <Typography className="it-fl">Band Size :</Typography>
          <Typography className="it-fv">{t.bandsize || "—"}</Typography>
        </div>
        <div className="it-field">
          <Typography className="it-fl">No. of Links :</Typography>
          <Typography className="it-fv">{t.links || "—"}</Typography>
        </div>
        <div className="it-field">
          <Typography className="it-fl">Box :</Typography>
          <Typography className="it-fv"><YesNo val={yn(t.warrantypaper || "—")} /></Typography>
        </div>
      </div>
    </div>
  );

  /* ── Pending Card ── */
  const renderPendingCard = (t) => (
    <div key={t.inventoryid} className="it-card">
      <div className="it-card-top">
         <div className="it-field">
          <Typography className="it-f2">From: </Typography>
          <Typography className="it-from">{t.from_businessname} </Typography>
        </div>
        <Typography className="it-date">{formatDate(t.transfer_date)}</Typography>
      </div>
      <div className="it-card-body">
        <InventoryPhoto t={t} />
        {renderFields(t)}
        <div className="it-right">
          <div className="it-price-block">
            <div>
              <Typography className="it-price-lbl">TRANSFER PRICE</Typography>
            </div>
            <div className="it-price">
              {t.transferprice != null ? `$ ${Number(t.transferprice).toLocaleString()}` : "—"}
            </div>
          </div>
          <div className="it-actions">
            <button className="it-btn it-btn-outline" onClick={() => openInvoice(t)}>Open Invoice</button>
            <button className="it-btn it-btn-gold" onClick={() => setAcceptModal(t)}>Accept Transfer</button>
            <button className="it-btn it-btn-red" onClick={() => setRejectModal(t)}>Reject Transfer</button>
          </div>
        </div>
      </div>
    </div>
  );

  /* ── Rejected Card ── */
  const renderRejectedCard = (t) => (
    <div key={t.inventoryid} className="it-card it-card-rejected">
      <div className="it-card-top it-card-top-rej">
        <Typography className="it-f2">From: </Typography> 
        <Typography className="it-from">{t.from_businessname} </Typography>
        {/* {activeTab === "rejected" && (
          <Typography className="it-rej-badge">
            REJECTED INVOICE
          </Typography>
        )} */}
        <Typography className="it-date">{formatDate(t.transfer_date)}</Typography>
      </div>

      {t.notes && (
        <div className="it-rej-reason">
          <span className="it-rej-reason-label">REJECTED REASON:</span>
          <span className="it-rej-reason-text"> {t.notes}</span>
          <i className="it-rej-on">
            {" "} ( REJECTED ON - {formatDate(t.rejected_date)} )
          </i>
        </div>
      )}

      <div className="it-card-body it-card-body-rej">
        <div className="it-photo">
          <InventoryPhoto t={t} />
        </div>
        {renderFields(t)}
        <div className="it-right">
          <div className="it-price-block">
            <div className="it-price-lbl">TRANSFER PRICE</div>
            <div className="it-price">
              {t.transferprice != null ? `$ ${Number(t.transferprice).toLocaleString()}` : "—"}
            </div>
          </div>
          <div className="it-actions">
            <button className="it-btn it-btn-outline" onClick={() => openInvoice(t)}>Open Invoice</button>
            <button className="it-btn it-btn-gold" onClick={() => setAcceptModal(t)}>Accept Transfer</button>
          </div>
        </div>
      </div>
    </div>
  );

  /* ── Accepted Card ── */
  const renderAcceptedCard = (t) => (
    <div key={t.inventoryid} className="it-card it-card-accepted">
      <div className="it-card-top it-card-top-acc">
        <Typography className="it-f2">From: </Typography> 
        <Typography className="it-from">{t.from_businessname} </Typography>
        {/* {activeTab === "accepted" && (
          <Typography className="it-acc-badge">
            ACCEPTED INVOICE
          </Typography>
        )} */}
        <Typography className="it-date">{formatDate(t.transfer_date)}</Typography>
      </div>

      {t.notes && (
        <div className="it-acc-reason">
          <span className="it-acc-reason-text"> {t.notes}</span>
        </div>
      )}

      <div className="it-card-body it-card-body-acc">
        <div className="it-photo">
          <InventoryPhoto t={t} />
        </div>
        {renderFields(t)}
        <div className="it-right">
          <div className="it-price-block">
            <div className="it-price-lbl">TRANSFER PRICE</div>
            <div className="it-price">
              {t.transferprice != null ? `$ ${Number(t.transferprice).toLocaleString()}` : "—"}
            </div>
          </div>
          <div className="it-actions">
            <button className="it-btn it-btn-outline" onClick={() => openInvoice(t)}>Open Invoice</button>
            <button className="it-btn it-btn-red" onClick={() => setRejectModal(t)}>Reject Transfer</button>
          </div>
        </div>
      </div>
    </div>
  );

  const contentView = (
    <div className="it-wrap">
      <div className="it-page">
        <h1 className="it-page-title">Inventory Transfers</h1>
        <p className="it-page-sub">Review and manage incoming inventory transfer requests from partner dealers.</p>

        <div className="it-tabs">
          <button
            className={`it-tab${activeTab === "pending" ? " it-tab-active" : ""}`}
            onClick={() => setActiveTab("pending")}
          >
            Pending
            <span className={`it-tab-count${activeTab === "pending" ? " it-tab-count-active" : ""}`}>
              {pendingCount}
            </span>
          </button>
          <button
            className={`it-tab${activeTab === "rejected" ? " it-tab-active" : ""}`}
            onClick={() => setActiveTab("rejected")}
          >
            Rejected
            <span className={`it-tab-count${activeTab === "rejected" ? " it-tab-count-active" : ""}`}>
              {rejectedCount}
            </span>
          </button>
          <button
            className={`it-tab${activeTab === "accepted" ? " it-tab-active" : ""}`}
            onClick={() => setActiveTab("accepted")}
          >
            Accepted
            <span
              className={`it-tab-count${
                activeTab === "accepted" ? " it-tab-count-active" : ""
              }`}
            >
              {counts.accepted}
            </span>
          </button>
        </div>
        {activeTab === "rejected" && (
          <div className="it-info-banner">
            <InfoIcon className="it-info-icon" />
            <span>
              Rejected inventory transfers will be permanently removed after <strong>30 days</strong> from the rejected date.
            </span>
          </div>
        )}

        {loading && (
          <div className="d-spinner">
            <SpinnerRoundFilled
              size={51}
              thickness={125}
              speed={80}
              color="rgba(57, 107, 172, 1)"
              className="spp"
              enabled={loading}
            />
          </div>
        )}
        {error && <div className="it-empty">Couldn't load transfers. Please try again.</div>}

        {/* Cards */}
        {!loading && !error && (
          displayList.length === 0 ? (
            <div className="it-empty">No {activeTab} transfers.</div>
          ) : (
           displayList.map((t) => {
            if (activeTab === "pending") {
              return renderPendingCard(t);
            }
            if (activeTab === "accepted") {
              return renderAcceptedCard(t);
            }
            return renderRejectedCard(t);
          })
          )
        )}
      </div>


      {rejectModal && (
        <Dialog
          open={Boolean(rejectModal)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth={true}
          maxWidth={'sm'}
          onClose={() => setRejectModal(null)}
        >
          <DialogTitle>
            Reject Transfer
            <IconButton onClick={() => setRejectModal(null)} style={{ float: 'right' }}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <div style={{ fontSize: "15px", lineHeight: 1.6 }}>
              Rejecting the inventory transfer will move the inventory to <b>Rejected</b> status. You can view it in the <b>Rejected</b>  tab, where you can review and accept it at any time. If no action is taken within <b>30 days</b>, the inventory will be permanently removed.
              <br />
              <p><b>Still want to reject the transfer?</b> Please enter the reason below before proceeding.</p>
            </div>
            <div>
            <FormControl style={{ width: '400px', margin: '20px 0px' }}>
            <TextField
              variant="outlined"
              multiline
              rows={2}
              required
              fullWidth
              required={true}
              placeholder="Please enter the reason for rejection*"
              style={{ width: '400px !important' }}
              value={rejectNotes}
              onChange={(e) => setRejectNotes(e.target.value)}
            />
            </FormControl></div>
          </DialogContent>
          <DialogActions>
            <Button
              variant="outlined"
              style={{ background: "#fff", color: "#000" }}
              onClick={() => {
                setRejectModal(null);
                setRejectNotes("");
              }}
            >
              Cancel
            </Button>
            <Button
              variant="text"
              style={{ background: "#000", color: "#fff" }}
              onClick={() => confirmReject(rejectModal)}
              disabled={rejecting || !rejectNotes.trim()}
            >
              {rejecting ? "Rejecting..." : "Confirm Rejection"}
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {acceptModal && (
        <Dialog
          open={Boolean(acceptModal)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth={true}
          maxWidth={'sm'}
          onClose={() => setAcceptModal(null)}
        >
          <DialogTitle>
            Accept Transfer
            <IconButton onClick={() => setAcceptModal(null)} style={{ float: 'right' }}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <div style={{ fontSize: "15px", lineHeight: 1.6 }}>
              Confirm acceptance of this transfer?{" "}
              <strong>{inventoryName}</strong> will be
                  added to your WatchOps Inventory with all transferred fields pre-populated.
            </div>
            {(isShopifyVerified() || isQboVerified()) && (
              <div style={{ marginTop: "13px", display: "flex", flexDirection: "column", gap: "4px" }}>
                {isShopifyVerified() && (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={includeShopify}
                        onChange={(e) => setIncludeShopify(e.target.checked)}
                      />
                    }
                    label={<strong>Sync this item to Shopify</strong>}
                  />
                )}
                {isQboVerified() && (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={includeQbo}
                        onChange={(e) => setIncludeQbo(e.target.checked)}
                      />
                    }
                    label={<strong>Sync this item to QuickBooks</strong>}
                  />
                )}
              </div>
            )}
          </DialogContent>
          <DialogActions>
            <Button variant="outlined" style={{ background: "#fff", color: "#000" }} onClick={() => setAcceptModal(null)}>Cancel</Button>
            <Button variant="text" 
              style={{ background: "#000", color: "#fff" }} 
              onClick={() => confirmAccept(acceptModal)}
              disabled={confirmAccepts}
              endIcon={
                confirmAccepts ? (
                 <CircularProgress
                  style={{ width: 22, height: 22, color: "#fff" }}
                 />
                ) : null
              }
            >
              {confirmAccepts ? "Accepting..." : "Confirm Accept"}
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {viewInvoiceModal && selectedInvoice && (
        <ViewInvoicemodel
          open={viewInvoiceModal}
          handleClose={handleCloseAction}
          invoiceid={{
            id: selectedInvoice?.invoiceid,
            memoid: selectedInvoice?.memoid,
            invoicetype: selectedInvoice?.invoicetype,
            inventoryid: selectedInvoice?.inventoryid,
          }}
        />
      )}
    </div>
  );

  return <ContentWrapper contentView={contentView} />;
};

export default InventoryTransferComponent;